/*
 *  Carousel Section
 *    Superclass for any carousel section you build, provides nice defaults that
 *    can be provided as data attributes from the wrapped container.
 *
 *  Version:
 *    1.0.0 - 2023/07/11
 */

import 'slick-carousel';

import { ShopifySection } from '../ShopifySection';

export const NEXT_SELECTOR = '[data-slick-arrow-next]';
export const PREV_SELECTOR = '[data-slick-arrow-prev]';
export const CLASS_INITIALIZED = 'slick-initialized';

export class CarouselSection extends ShopifySection {
  constructor(container) {
    super(container);

    this.options = {
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      swipeToSlide: true,
      cssEase: this.container.css('animation-timing-function') || 'cubic-bezier(0.455, 0.030, 0.515, 0.955)',
      touchThreshold: 200
    };
  }

  initCarousel(carouselElement, moreOverrides) {
    moreOverrides = moreOverrides || {};
    let slick = carouselElement.slick({
      ...this.options,
      ...this.optionOverrides(),
      ...moreOverrides
    });
    return slick;
  }

  optionOverrides() { return {}; }
}
